import { useAppRouter } from '@/common/route/useAppRouter';
import { timeUnits } from '@/common/utils/helpers';
import { validateFormat } from '@/common/validator/validatorHelpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_LEAGUE } from '@/modules/league/router';
import { leagueService } from '@/services/league';
import { useVuelidate } from '@vuelidate/core';
import { maxValue, minValue, numeric, required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useLeagueEdit() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        id: route.params.id,
        timeUnit: 1,
        timeDuration: 1,
        game: null,
        maxPlayer: null,
        penaltyPoint: null,
        defaultPoint: null,
        positionPoints: null,
        startTime: new Date(),
        season: null,
        canDelete: false
    });

    const validations = {
        timeDuration: { required, numeric, min: minValue(1), max: maxValue(3200) },
        game: { required, numeric, min: minValue(0), max: maxValue(3200) },
        maxPlayer: { required, numeric, min: minValue(5), max: maxValue(200) },
        defaultPoint: { required, numeric, min: minValue(0), max: maxValue(3200) },
        penaltyPoint: { required, max: maxValue(0) },
        positionPoints: { format: validateFormat(/^\d+(;\d+)*$/) }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: () => leagueService.item.get(model.id),
        onSuccess: ({ data }) => {
            data.startTime = new Date(data.startTime);
            Object.assign(model, data);
        },
        onError: () => router.push({ name: ROUTE_NAME_LEAGUE.INDEX })
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () =>
                leagueService.item.update(
                    model.id,
                    model.timeUnit,
                    model.timeDuration,
                    model.game,
                    model.maxPlayer,
                    model.defaultPoint,
                    model.penaltyPoint,
                    model.positionPoints,
                    model.startTime.getTime()
                ),
            onSuccess: () => router.push({ name: ROUTE_NAME_LEAGUE.INDEX })
        }),
        remove: crudAction.confirmAndRemove({
            request: () => leagueService.item.remove(model.id),
            onSuccess: () => router.push({ name: ROUTE_NAME_LEAGUE.INDEX })
        })
    };

    return { model, v$, fetch, actions, timeUnits };
}
